module.exports = __webpack_public_path__ + "img/Ausbildungszentrum.9b3d90fd.svg";